(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["LT-video-with-text"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kdara-market-film')) {
  customElements.define('kdara-market-film', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('.marketFilmToggle');
      if (!this.video || !this.button) return;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.loop = true;
      this.video.playsInline = true;
      this.video.controls = false;
      this.visible = false;
      this.userPaused = false;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.manualPlay = false;
      this.sync = () => {
        this.button.textContent = this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.button.setAttribute('aria-label', this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      };
      this.play = () => {
        const result = this.video.play();
        if (result) result.catch(() => this.sync());
      };
      this.update = () => {
        if (this.visible && !document.hidden && !this.userPaused && (!this.reduced.matches || this.manualPlay)) this.play();
        else this.video.pause();
      };
      this.toggle = () => {
        this.userPaused = !this.video.paused;
        if (this.userPaused) this.video.pause();
        else { this.manualPlay = true; this.play(); }
      };
      this.button.addEventListener('click', this.toggle);
      this.video.addEventListener('play', this.sync);
      this.video.addEventListener('pause', this.sync);
      document.addEventListener('visibilitychange', this.update);
      this.reduced.addEventListener('change', this.update);
      this.video.pause();
      this.sync();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.update();
        }, { threshold:0.15 });
        this.observer.observe(this.video);
      } else { this.visible = true; this.update(); }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.toggle);
      this.video?.removeEventListener('play', this.sync);
      this.video?.removeEventListener('pause', this.sync);
      document.removeEventListener('visibilitychange', this.update);
      this.reduced?.removeEventListener('change', this.update);
      this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
